import * as React from "react";
import {createRoot} from "react-dom/client";

import {linguiInit} from "@khan/i18n";

const ExecPythonApp = React.lazy(
    () => import("./python-sandbox/exec-python-app.tsx"),
);

async function start(
    initializer: (hostname: string) => Promise<void>,
    useStrings: () => Record<string, string | string[]> | undefined,
) {
    linguiInit();

    try {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- we're using this in a non-React context
        useStrings();
    } catch (promise) {
        await promise;
    }

    const root = document.getElementById("app-shell-root");
    const div = document.createElement("div");
    div.id = "live-editor-output";

    if (root) {
        root.appendChild(div);
        // eslint-disable-next-line no-restricted-syntax -- it's safe to access window.location.hostname here
        initializer(window.location.hostname);
    }
}

// WARNING(kevinb): This is not the standard way of loading strings.  The reason
// why we do things this way here is that none of exec-pjs-frame, exec-sql-frame,
// and exec-webpage-frame use React to render their contents.
async function load(): Promise<void> {
    if (location.pathname === "/computer-programming/exec/pjs") {
        const [{init}, {useStrings}] = await Promise.all([
            import("./exec/exec-pjs-frame.tsx"),
            import("./exec/locales/exec-pjs-frame/load-strings.tsx"),
        ]);
        return start(init, useStrings);
    }

    if (location.pathname === "/computer-programming/exec/sql") {
        const [{init}, {useStrings}] = await Promise.all([
            import("./exec/exec-sql-frame.tsx"),
            import("./exec/locales/exec-sql-frame/load-strings.tsx"),
        ]);
        return start(init, useStrings);
    }

    if (location.pathname === "/computer-programming/exec/webpage") {
        const [{init}, {useStrings}] = await Promise.all([
            import("./exec/exec-webpage-frame.tsx"),
            import("./exec/locales/exec-webpage-frame/load-strings.tsx"),
        ]);
        return start(init, useStrings);
    }

    if (location.pathname === "/computer-programming/exec/python") {
        const domContainer = document.getElementById("app-shell-root");

        // eslint-disable-next-line no-restricted-syntax -- it's safe to access domContainer here
        const root = createRoot(domContainer!);
        root.render(<ExecPythonApp />);

        return Promise.resolve();
    }

    return Promise.reject(new Error("invalid pathname"));
}

load();
